(function () {
  if (window.__letterSelectSyncLoaded) return;
  window.__letterSelectSyncLoaded = true;

  function syncLetter(select) {
    var value = select.value;
    var radios = document.querySelectorAll('input[data-option-name="Letter or Number Choice"]');
    radios.forEach(function (radio) {
      if (radio.value === value && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
        radio.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  }

  function attach() {
    var selects = document.querySelectorAll(".__letter-select");
    if (selects.length === 0) return;
    selects.forEach(function (sel) {
      sel.addEventListener("change", function () {
        syncLetter(sel);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attach);
  } else {
    attach();
  }
})();
